module.exports = ":host {\n    text-align: center;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/assessment-charts/scale-chart/scale-chart.component.css
// module id = ./src/app/assessment-charts/scale-chart/scale-chart.component.css
// module chunks = main